import { ListItem, Avatar } from "react-native-elements";
// import TouchableScale from "react-native-touchable-scale"; // https://github.com/kohver/react-native-touchable-scale
import React, { Component } from "react";
import { ScrollView, Text, View } from "react-native";
import colorArr from "../utils/colorArr";

import Header from "./Header";
export default class LeaderBoard extends Component {
  render() {

    console.log("LeaderBoard")
    return <Header navigation={this.props.navigation}/>;
  }
}
